
import { useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface MobileModuleSelectorProps {
  onModuleSelect: (module: string) => void;
}

const MobileModuleSelector = ({ onModuleSelect }: MobileModuleSelectorProps) => {
  const [selectedModule, setSelectedModule] = useState("none");

  const handleSelect = (value: string) => {
    setSelectedModule(value);
    onModuleSelect(value);
  };

  return (
    <div className="w-full font-newgrotesk">
      <Select value={selectedModule} onValueChange={handleSelect}>
        <SelectTrigger className="w-full bg-white border-gray-200 focus:ring-neon-green text-black font-newgrotesk">
          <SelectValue placeholder="View Analytics" className="text-black !text-black font-newgrotesk" />
        </SelectTrigger>
        <SelectContent className="bg-white font-newgrotesk">
          <SelectItem value="schedule" className="text-black font-newgrotesk">My Schedule</SelectItem>
          <SelectItem value="earnings" className="text-black font-newgrotesk">My Earnings</SelectItem>
          <SelectItem value="ratings" className="text-black font-newgrotesk">My Ratings</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default MobileModuleSelector;
